import React from 'react';
import { Link } from 'react-router-dom';

const Science: React.FC = () => (
  <section id="science" className="bg-soft-gray py-12 lg:py-16">
    <div className="container-custom max-w-4xl text-center">
      <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-4">Understand Your Pet’s Dental Care</h2>
      <p className="text-lg text-gray-600 mb-8">Read veterinary guidance and prepare questions about examination, dental X-rays, anesthesia, and treatment.</p>
      <div className="grid sm:grid-cols-3 gap-4 text-left">
        <Link to="/blog/is-anesthesia-safe-for-pet-dental-cleaning" className="block bg-white rounded-xl p-6 border border-gray-200 hover:border-brand-teal">
          <h3 className="text-xl font-semibold mb-2">Anesthesia</h3>
          <p className="text-gray-600">Assessment, risks, and questions for your veterinarian.</p>
        </Link>
        <Link to="/blog/cat-dental-disease-signs-treatment" className="block bg-white rounded-xl p-6 border border-gray-200 hover:border-brand-teal">
          <h3 className="text-xl font-semibold mb-2">Cat Dental Health</h3>
          <p className="text-gray-600">Signs, examination, and treatment questions.</p>
        </Link>
        <Link to="/research" className="block bg-white rounded-xl p-6 border border-gray-200 hover:border-brand-teal">
          <h3 className="text-xl font-semibold mb-2">Veterinary Sources</h3>
          <p className="text-gray-600">Guidance from AAHA and Cornell.</p>
        </Link>
      </div>
    </div>
  </section>
);

export default Science;
